<template>
  <cms-recommendation-carousel
    :currency="currency[locale]"
    :products="recommendedProducts"
    :quickshop
    :title="content.title"
    :variant="content.variant"
    @product-click="handleProductClick"
  />
</template>

<script lang="ts" setup>
import type { ProductRecommendations } from '#types/components/cms/product-recommendations'
import type { MonetateExtractedProduct } from '#types/p13n'
import { getPageInfo } from '#commerce/gtm/page'

const props = defineProps<{ content: ProductRecommendations }>()

const { currency } = useRuntimeConfig().public
const { sendMonetateEvents, sendRecImpressionsEvent, extractProduct } = useMonetate()
const { $gtm } = useNuxtApp()
const locale = useLocale()
const route = useRoute()
const { enableQuickShop } = useAppConfig().components.cms.productRecommendations

const quickshop = props.content.quickShopVisibility ? props.content.quickShopVisibility === 'visible' : enableQuickShop

const recommendedProducts = computed<MonetateExtractedProduct[]>(() =>
  props.content.recommendedProducts?.map((product) =>
    extractProduct(product, props.content.showRatings)
  )
)

const handleProductClick = (product, position: number) => {
  const [pageCategory] = getPageInfo(route, {})
  sendMonetateEvents([{
    eventType: 'monetate:record:RecClicks',
    recClicks: [product.recToken]
  }])

  $gtm.push('product.onProductRecClick', product, position, {
    action: 'Click Recommendation',
    currency: currency[locale],
    experience: props.content.monetateDecision,
    list: `${pageCategory || 'Home'} | Product Recommendation Carousel`,
    title: props.content.title,
    vendor: 'monetate'
  })
}

onMounted(() => {
  const [pageCategory] = getPageInfo(route, {})
  if (props.content.monetateDecision?.name !== 'Control' && props.content.recommendedProducts?.length) {
    sendRecImpressionsEvent(props.content.recommendedProducts, 24)
    $gtm.push('product.onProductRecImpressions', props.content.recommendedProducts, {
      currency: currency[locale],
      experience: props.content.monetateDecision,
      list: `${pageCategory || 'Home'} | Product Recommendation Carousel`,
      title: props.content.title
    })
  }
})
</script>
